<template>
<div>
    
<b-card no-body class="marginal" style="margin-top:0px; margin-bottom:20px">
  <b-card-header header-bg-variant="msstream" header-text-variant="white" class="text-center">
    <h6 style="margin:0px">{{$ml.get('newcollection')}}</h6>
  </b-card-header>
  <b-card-body >
    <b-form @submit.prevent="onSubmit()">
      <div class="border-error" v-if="error_" show>{{error_}}</div>
        <b-form-group
                    id="vodGroup1"
                    label=""
                    label-for="vodInput1">
          <b-input-group size="sm" :prepend="$ml.get('config2')">
            <b-form-input
              id="vodInput1"
              type="text"
              v-model.trim="name"
              required
              :placeholder="$ml.get('config2')"
            >
            </b-form-input>
          </b-input-group>
        </b-form-group>

        <b-row class="justify-content-center">
          <b-col cols="auto">
            <b-button size="sm" type="submit" variant="msstreamblue">
            <b-icon icon="check2-square" />
            {{$ml.get('confsubmit')}}
            </b-button>
          </b-col>
        </b-row>
    </b-form> 
  </b-card-body>
</b-card>
</div>
</template>

<script>
import CollectionService from "@/services/collection.service";
var collectionService = new CollectionService();
export default {
  name: "NewCollection",
  data: function () {
    return {
      clientView: this.$auth.getMyUser().roles.indexOf("admin") > -1
        ? this.$auth.getMyClientView() || this.$auth.getMyUser().client
        : this.$auth.getMyUser().client,
      name: "",
      error_: ""
    };
  },
  mounted: function () {},
  methods: {
    onSubmit: function () {
        this.error_ = "";
        collectionService.postCollection({name: this.name, client: this.clientView}, this.$auth.token())
        .then(() => {
            console.log("new collection")
            this.$emit('closeModal', true)
        }).catch(err => {
            this.error_ = this.$ml.get("errornewcollection")
        })
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.border-error {
  border: 1px solid #ba0000;
  border-radius: 10px;
  background-color: rgba(#ba0000, 0.2);
  color: #ba0000;
  padding: 10px;
  margin-bottom: 15px;
}

</style>
